/**
 * Seeds localStorage from a `render_token` URL query param so a headless
 * browser session (Playwright, launched server-side by ServerPdfExporter to
 * compile the emailed report PDF) lands on a protected route already
 * authenticated — identical to a normal logged-in browser tab.
 *
 * Must run synchronously before the app tree first renders, since
 * ProtectedRoute reads localStorage during its own render (not in an effect).
 */
export function bootstrapRenderSession(): void {
  const params = new URLSearchParams(window.location.search)
  const renderToken = params.get('render_token')
  if (!renderToken) return

  localStorage.setItem('access_token', renderToken)

  const renderUid = params.get('render_uid')
  if (renderUid) localStorage.setItem('user_id', renderUid)

  // The month-end report pipeline only ever renders for brand-owner accounts.
  localStorage.setItem('account_type', 'brand')
}
